// Stranica sezonske karte: brojači po kategoriji, ukupno uživo, "Dalje" kreira ecomm.ski zapis po karti
// (isti ugovor kao ag-ecommski-product-form.js: POST /api/custom-products -> data.id u _ecomm_ski_product_id)
// i dodaje sve u korpu jednim /cart/add.js pozivom.
// v2.0.10: nijedna karta ne ide u korpu bez ecomm.ski zapisa. Ranije je "+" pa "−" prije "Dalje" ostavljao rupu u listi
// zapisa (ids.length = n produžavao prazan niz), za tu kartu zapis se nije kreirao i otišla je u korpu bez
// _ecomm_ski_product_id, pa je plaćena bez podataka osobe (OCBI10944, 10950, 10965, 10977, 10989, 11000).
// Brojači su i zaključani dok traje "Pripremam korpu...".
(function () {
  var API = 'https://admin.ecomm.ski/api/custom-products';

  function fmt(cents) {
    // ručno formatiranje (1.234,56 KM): ne zavisi od jezičkih podataka preglednika
    var parts = (cents / 100).toFixed(2).split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1] + ' KM';
  }
  function cardsWord(n) {
    var m = n % 100, d = n % 10;
    if (n === 1) return '1 karta';
    if (m >= 11 && m <= 14) return n + ' karata';
    if (d >= 2 && d <= 4) return n + ' karte';
    return n + ' karata';
  }

  function init(root) {
    if (root.dataset.agInit) return;
    root.dataset.agInit = '1';
    var max = Number(root.dataset.max) || 10;
    var productId = root.dataset.productId;
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-ag-row]')).map(function (el) {
      return {
        el: el,
        variant: el.dataset.variant,
        price: Number(el.dataset.price),
        n: 0,
        ids: [],
        out: el.querySelector('[data-ag-n]'),
        minus: el.querySelector('[data-ag-minus]'),
        plus: el.querySelector('[data-ag-plus]'),
        soldOut: !!el.querySelector('[data-ag-plus]').disabled,
      };
    });
    var label = root.querySelector('[data-ag-label]');
    var total = root.querySelector('[data-ag-total]');
    var go = root.querySelector('[data-ag-go]');
    var msg = root.querySelector('[data-ag-msg]');
    var busy = false;
    var ctaText = go.textContent;

    function render() {
      var count = 0, sum = 0;
      rows.forEach(function (r) {
        count += r.n;
        sum += r.n * r.price;
        r.out.textContent = r.n;
        r.minus.disabled = busy || r.n === 0;
        r.plus.disabled = busy || r.soldOut || r.n >= max;
      });
      label.textContent = count ? cardsWord(count) + ' · ' + root.dataset.group + ' ' + root.dataset.pack.replace(/^Sezonska\s+/, '') : 'Izaberite broj karata';
      total.textContent = fmt(sum);
      go.setAttribute('aria-disabled', count && !busy ? 'false' : 'true');
    }

    rows.forEach(function (r) {
      r.n = Number(r.el.dataset.default) || 0;
      r.minus.addEventListener('click', function () { if (busy) return; if (r.n > 0) { r.n--; if (r.ids.length > r.n) r.ids.length = r.n; msg.textContent = ''; render(); } });
      r.plus.addEventListener('click', function () { if (busy) return; if (r.n < max) { r.n++; msg.textContent = ''; render(); } });
    });

    async function createRecord(variant) {
      var response = await fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ shopify_product_id: productId, shopify_variant_id: variant }),
      });
      var json = await response.json();
      var id = json && json.data && json.data.id;
      if (!response.ok || !id) throw new Error('ecomm.ski: no record id');
      return id;
    }

    go.addEventListener('click', async function () {
      if (busy || go.getAttribute('aria-disabled') === 'true') return;
      busy = true;
      go.textContent = 'Pripremam korpu...';
      render();
      msg.textContent = '';
      try {
        // zapis se kreira za svaku kartu koja ga još nema, i za "rupe" nakon neuspjelog pokušaja (ponovni pokušaj ne pravi duplikate)
        var jobs = [];
        rows.forEach(function (r) {
          for (var i = 0; i < r.n; i++) {
            if (r.ids[i]) continue;
            (function (row, index) {
              jobs.push(createRecord(row.variant).then(function (id) { row.ids[index] = id; }));
            })(r, i);
          }
        });
        await Promise.all(jobs);
        var items = [];
        rows.forEach(function (r) {
          for (var i = 0; i < r.n; i++) {
            if (!r.ids[i]) throw new Error('ecomm.ski: missing record for ticket ' + (i + 1));
            items.push({ id: Number(r.variant), quantity: 1, properties: { _ecomm_ski_product_id: r.ids[i] } });
          }
        });
        if (!items.length) throw new Error('no tickets selected');
        var add = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        });
        if (!add.ok) throw new Error('cart add failed: ' + add.status);
        window.location.href = '/cart';
      } catch (error) {
        console.error(error);
        msg.textContent = 'Došlo je do greške, molimo pokušajte ponovo.';
        go.textContent = ctaText;
        busy = false;
        render();
      }
    });

    render();

    // Povratak na stranicu tipkom "nazad" (iOS Safari/bfcache vraća stranicu u stanju prije odlaska u korpu):
    // otključaj dugme, vrati tekst i kreni od početnog izbora. Karte iz prethodnog koraka su već u korpi,
    // a njihovi ecomm.ski zapisi se ne smiju ponovo slati (isti zapis bi se spojio u količinu 2).
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      busy = false;
      go.textContent = ctaText;
      msg.textContent = '';
      rows.forEach(function (r) { r.n = Number(r.el.dataset.default) || 0; r.ids = []; });
      render();
    });
  }

  function boot() { document.querySelectorAll('[data-ag-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
